import { ENV_DEVELOPMENT } from './common';

export const API_BASE_URL =
    process.env.REACT_APP_ENV === ENV_DEVELOPMENT
        ? 'https://api-phonecheckr.salesmsgdev.com/api'
        : 'https://api.phonecheckr.com/api';
